import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate();
});
